import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import Pagination from "../Pagination";
import Loader from "../../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import API from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const WagerList: React.FC = () => {

    const [loading, setLoading] = useState(false);
    const [games, setGames] = useState<any>([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const navigate = useNavigate();
    const [count, setCount] = useState<any>(0);
    const [page1, setPage1] = useState(1);
    const isFirstRender = useRef(true);

    const getBetList = async () => {
        if (isFirstRender.current) {
            setLoading(true);
            isFirstRender.current = false;
        }

        let response;
        try {
            response = await API.post(`/webapp/get-casino-wager-games`, {

                is_wager: false,
                page_no: page1,
                page_size: rowsPerPage

            });
        } catch (e) {
            console.log(e);
            setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            toast.error(response.data?.error_description)
            navigate("/home");
        }

        if (response && response.data?.games) {
            setGames(response?.data?.games);
            if (page1 === 0 || page1 === 1) {
                setCount(response?.data?.count);
            }
        }
        setLoading(false);
    };



    const handleBackClick = () => {
        navigate(-1);
    };

    useEffect(() => {
        getBetList();
    }, [])






    return (
        <>
            <>
                <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] bet-list">
                    {
                        loading ? (
                            <div className="home-loading">
                                <img src={Loader} style={{ height: '10rem' }} />
                            </div>
                        ) : (
                            <>
                                <header className="flex gap-3 items-center self-start text-base font-medium text-center text-white mb-[0.5rem] w-full">
                                <div>
                                <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                                    onClick={() => handleBackClick()}
                                >
                                    <ArrowBackIcon
                                        className="text-border-color aspect-square w-[18px]"
                                        style={{ width: '20px', height: '20px' }}
                                    />
                                </div>
                                </div>
                                <h2 className="self-stretch my-auto">Games List</h2>
                                </header>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full border-collapse user-table border-x mt-1">
                                        <thead>
                                            <tr>
                                                <th className="px-4 py-2 text-left border-b border-t">Game</th>
                                                <th className="px-4 py-2 text-left border-b border-t">Provider</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {games.map((row: any, index: number) => (
                                                <tr key={index} className="border-b"
                                                >

                                                    <td className="p-2">{row?.game_name}</td>
                                                    <td className="p-2">
                                                        {row?.provider_name}
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                                <Pagination currentPage={page1} setCurrentPage={setPage1} setRowsPerPage={setRowsPerPage} rowsPerPage={rowsPerPage} eventsCount={count} callBackFunc={getBetList} />
                            </>
                        )
                    }
                </div>
            </>
        </>
    );
};

export default WagerList;
